export default {
    ADMIN: "ADMIN",
    CEO: "CEO",
    HEAD: "HEAD",
    INVESTIGATOR: "INVESTIGATOR"
}